import styles from '../Home.module.css'
import Grid from "@mui/material/Grid"
import Typography from "@mui/material/Typography"
import dynamic from "next/dynamic"
import { isDefined, count, round } from '@components/config/helpers'
import Image from 'next/image'
import useGlobalSettings from '@components/_hooks/useGlobalSettings'
import useWindowSize from '@components/_hooks/useWindowSize'

const ProductCardPriceBreaks = dynamic(() => import('./ProductCardPriceBreaks'))

const ProductCardKeyFeatures = (props) => {
    const {
        long_term_product,
        key_features,
        price_breaks,
        product,
        ecoLeaf=false,
        key_features_md_column = 6,
    } = props;

    const { getSetting} = useGlobalSettings()
    const { isMobile } = useWindowSize()

    return (
       <Grid className={`mb-2 mt-2 w-100 p-0 ${product.package_core_group_id != null ? 'd-none': ''}`} container>
            
            {long_term_product != true && !isDefined(price_breaks) || count(price_breaks) == 0 ? (
                key_features?.map((feature, idx) => (
                    <Grid key={idx} item xs={12} md={key_features_md_column}>
                    
                        
                        <Typography className={`p-1 ${styles.list} `}><Typography className="f-size_2 pt-0 " component="span">
                            {feature.value}
                            
                        </Typography></Typography>
                    
                    </Grid>
                ))
            ) : (
                <Grid itemxs={12} md={key_features_md_column}>
                    {key_features?.map((feature, idx) => (
                        <Typography key={idx} className={`p-1 ${styles.list} `}><Typography className="f-size_2 pt-0 " component="span">
                            {feature.value}
                        </Typography></Typography>
                    ))}
                </Grid>
            )
            }



        {/* Price break To Card */}

        {
            long_term_product != true && isDefined(price_breaks) && count(price_breaks) > 0 && (
                <ProductCardPriceBreaks
                    product={product}
                    long_term_product={long_term_product}
                    price_breaks={price_breaks}
                />
            )
        }

        {/* Eco Leaf Section */}
        {getSetting('carbon_footprint', 'no') == 'yes' && ecoLeaf &&
            <Grid className='mt-3' sx={{ width: '90%' }}>
                <Image
                    src={'/images/eco-leaf-transparent.png'}
                    alt='Eco leaf logo goes here'
                    width={`${!isMobile ? 75 : 50}`}
                    height={`${!isMobile ?  80 : 55}`}
                    className={`f-right ${isMobile ? 'mt-3' : ''}`}
                />

                <Typography color='primary' fontSize={17}>Carbon Footprint</Typography>
                <hr className={`my-4 ${isMobile ? 'f-left' : ''}`} style={{ width: `${isMobile ? '18rem' : ''}` }}></hr>
                <Typography>
                    Manufacturing this product on average creates <Typography variant='strong' color='primary'>{round(product.carbon[0].co2_total, 2)} kgCO2e</Typography> (kg of carbon dioxide equivalent). 
                    Fulfilling your requirements by hiring instead of purchasing, you are looking at a much smaller carbon footprint: <Typography variant='strong' color='primary'>{round(product.carbon[0].co2_net_item, 3)} kgCO2e</Typography>.
                    Thank you for being part of the solution to saving our planet.
                </Typography>
            </Grid>
        }
    </Grid>
    )
}

export default ProductCardKeyFeatures